import actions from './actions'

export default function ClinYearPricesReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_CLINYEARPRICE:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_CLINYEARPRICE:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_CLINYEARPRICE:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_CLINYEARPRICE:
      return {
        ...state,
        editing: { clinYearPriceID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_CLINYEARPRICE_RECIEVED ||
      actions.UPDATE_CLINYEARPRICE_RECIEVED ||
      actions.DELETE_CLINYEARPRICE_RECIEVED:
      return {
        ...state,
        editing: { clinYearPriceID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
